import { getRequest, postRequest, putRequest } from "./axiosClient";

export const createAdditionalPrint = (data) => postRequest('additionalPrints/createAdditionalPrint', data);
